<template>
  <div class="wholeEdit">
    <el-container class="wholeEdit-left">
      <el-header class="top">
        <div style="width:30%">
          <img src="@/assets/images/wpsp/Customer-view/资产汇总.png" />
          <span>金融资产(元)</span>
        </div>
        <div class="money"
             style="width:60%">
          <div >
            <p>¥{{ total.inBankAll | addMoneyFilter }}</p>
            <p>行内</p>
          </div>
          <div>
            <p>¥{{ total.outBankAll | addMoneyFilter }}</p>
            <p>行外</p>
          </div>
          <div>
            <p>¥{{ total.sumMoney | addMoneyFilter }}</p>
            <p>总计</p>
          </div>
        </div>
      </el-header>
      <el-container style="height:170px;border: 1px solid rgba(220, 223, 230, 1);border-top: 0px">
        <el-aside width="45px"
                  class="content-left">
          固
          <br />收
          <br />类
        </el-aside>
        <el-main class="content-Middle">
          <div class="table">
            <span style="width:80px;">理财</span>
            <span style="width:130px;text-align: right;">¥{{ within.finance | addMoneyFilter }}</span>
            <el-input maxlength="13" v-model="external.finance" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table background">
            <span style="width:80px;">大额存单</span>
            <span style="width:130px;text-align: right;">¥{{ within.largeDeposit | addMoneyFilter }}</span>
            <el-input maxlength="13" v-model="external.largeDeposit" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table">
            <span style="width:80px;">债券基金</span>
            <span style="width:130px;text-align: right;">¥{{ within.bondFund | addMoneyFilter }}</span>
            <el-input maxlength="13"  v-model="external.bondFund" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table background">
            <span style="width:80px;">定期存款</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.deposit | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.deposit" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table">
            <span style="width:80px;">债券</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.bond | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.bond" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table background">
            <span style="width:80px;">可转债</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.convertibleBond | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.convertibleBond" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table">
            <span style="width:80px;">国债逆回购</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.reRepurchaseNationalDebt | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.reRepurchaseNationalDebt" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table background">
            <span style="width:80px;">信托计划</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.trustScheme | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.trustScheme" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table">
            <span style="width:80px;">其他固收资产</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.otherFixedIncomeAssets | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.otherFixedIncomeAssets" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
        </el-main>
       <el-aside width="150px" class="content-right">
          <el-input maxlength="13"  v-model="sumTotal.fixIncomeMoney" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
        </el-aside>
      </el-container>
      <el-container style="height:110px;border: 1px solid rgba(220, 223, 230, 1);border-top: 0px">
        <el-aside width="45px"
                  class="content-left">
          货
          <br />币
          <br />类
        </el-aside>
        <el-main class="content-Middle">
          <div class="table">
            <span style="width:80px;">现金及活存</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.cash | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.cash" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table background">
            <span style="width:80px;">货币基金</span>
            <span style="width:130px;text-align: right;">¥{{ within.currencyFund | addMoneyFilter }}</span>
            <el-input maxlength="13"  v-model="external.currencyFund" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table">
            <span style="width:80px;">其他货币资产</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.otherMonetaryAssets | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.otherMonetaryAssets" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
        </el-main>
        <el-aside width="150px" class="content-right">
          <el-input maxlength="13"  placeholder="请输入内容" style="width:150px; " v-model="sumTotal.currencyMoney" class="external"></el-input>
        </el-aside>
      </el-container>
      <el-container style="height:110px;border: 1px solid rgba(220, 223, 230, 1);border-top: 0px">
        <el-aside width="45px"
                  class="content-left">
          权
          <br />益
          <br />类
        </el-aside>
        <el-main class="content-Middle">
          <div class="table">
            <span style="width:110px;">指数/混合/股票基金</span>
            <span style="width:100px;text-align: right;">¥{{ within.mixFund | addMoneyFilter }}</span>
            <el-input maxlength="13"  v-model="external.mixFund" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table background">
            <span style="width:80px;">股票</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.shares | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.shares" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table">
            <span style="width:80px;">其他权益资产</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.otherEquityAssets | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.otherEquityAssets" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
        </el-main>
        <el-aside width="150px" class="content-right">
          <el-input maxlength="13"  placeholder="请输入内容" style="width:150px; " v-model="sumTotal.equityMoney" class="external"></el-input>
        </el-aside>
      </el-container>
      <el-container style="height:110px;border: 1px solid rgba(220, 223, 230, 1);border-top: 0px">
        <el-aside width="45px"
                  class="content-left">
          商
          <br />品
          <br />类
        </el-aside>
        <el-main class="content-Middle">
          <div class="table">
            <span style="width:80px;">纸黄金</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.paperGold | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.paperGold" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table background">
            <span style="width:100px;">黄金ETF联接基金</span>
            <span style="width:110px;text-align: right;">¥{{ within.goldEtfFeederFund | addMoneyFilter }}</span>
            <el-input maxlength="13"  v-model="external.goldEtfFeederFund" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
          <div class="table">
            <span style="width:80px;">其他商品资产</span>
            <!-- <span style="width:130px;text-align: right;">{{ within.otherCommodityAssets | addMoneyFilter }}</span> -->
            <span style="width:130px;text-align: right;">-</span>
            <el-input maxlength="13"  v-model="external.otherCommodityAssets" placeholder="请输入内容" style="width:150px;" class="external"></el-input>
          </div>
        </el-main>
        <el-aside width="150px" class="content-right">
          <el-input maxlength="13"  placeholder="请输入内容" style="width:150px; " v-model="sumTotal.commodityMoney" class="external"></el-input>
        </el-aside>
      </el-container>
    </el-container>
    <div class="wholeEdit-right">
      <el-container class="top" style="margin-top: 40px;">
        <el-header class="first-line">
          <div>
            <img src="@/assets/images/wpsp/Customer-view/资产汇总.png" />
            <span>实物资产(元)</span>
          </div>
          <div>¥{{ total.physicalAssetsMoney | addMoneyFilter }}</div>
        </el-header>
       <el-main class="content">
          <div class="table">
            <span>房产</span>
            <el-input maxlength="13" v-model="external.houseProperty" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
          <div class="table background">
            <span>车辆</span>
            <el-input maxlength="13"  v-model="external.vehicle" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
          <div class="table">
            <span>收藏品</span>
            <el-input maxlength="13"  v-model="external.collection" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
          <div class="table background">
            <span>其他实物资产</span>
            <el-input maxlength="13"  v-model="external.otherPhysicalAssets" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
        </el-main>
      </el-container>
      <el-container class="bottom" >
        <el-header class="first-line">
          <div>
            <img src="@/assets/images/wpsp/Customer-view/资产负债表-selected.png" />
            <span>负债(元)</span>
          </div>
          <div>¥{{ total.liabilitiesMoney | addMoneyFilter }}</div>
        </el-header>
        <el-main class="content">
          <div class="table">
            <span>未还房贷</span>
            <el-input maxlength="13"  v-model="external.notMortgage" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
          <div class="table background">
            <span>未还车贷</span>
            <el-input maxlength="13"  v-model="external.notCarLoans" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
          <div class="table">
            <span>分期贷款消费</span>
            <el-input maxlength="13"  v-model="external.installmentLoan" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
          <div class="table background">
            <span>信用卡透支余额</span>
            <el-input maxlength="13"  v-model="external.creditcardOverdraftBalance" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
          <div class="table">
            <span>其他负债</span>
            <el-input maxlength="13"  v-model="external.otherLiabilities" placeholder="请输入内容" style="width:150px; "></el-input>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      editShow: true,
      // 行内行外总计信息
      total: {},
      // 行内行外总计之和
      sumTotal: {
        fixIncomeMoney: '',
        currencyMoney: '',
        equityMoney: '',
        commodityMoney: '',
      },
      // 修改前的总和
      beforeTotal: {
        fixIncomeMoney: '',
        currencyMoney: '',
        equityMoney: '',
        commodityMoney: '',
      },
      // 行内信息
      within: {},
      // 本人行外信息
      external: {},
      // 固收类行外其他备份
      otherFixedIncomeAssets: '',
      // 货币类行外其他备份
      otherMonetaryAssets: '',
      // 权益类行外其他备份
      otherEquityAssets: '',
      // 商品类行外其他备份
      otherCommodityAssets: '',
    };
  },
  props: ['cis', 'custRelationship'],
  watch: {
    // 修改固守总额
    'sumTotal.fixIncomeMoney': {
      handler() {
        this.external.otherFixedIncomeAssets = this.otherFixedIncomeAssets + (this.sumTotal.fixIncomeMoney - this.beforeTotal.fixIncomeMoney);
      },
    },
    // 修改货币总额
    'sumTotal.currencyMoney': {
      handler() {
        this.external.otherMonetaryAssets = this.otherMonetaryAssets + (this.sumTotal.currencyMoney - this.beforeTotal.currencyMoney);
      },
    },
    // 修改权益总额
    'sumTotal.equityMoney': {
      handler() {
        this.external.otherEquityAssets = this.otherEquityAssets + (this.sumTotal.equityMoney - this.beforeTotal.equityMoney);
      },
    },
    // 修改商品总额
    'sumTotal.commodityMoney': {
      handler() {
        this.external.otherCommodityAssets = this.otherCommodityAssets + (this.sumTotal.commodityMoney - this.beforeTotal.commodityMoney);
      },
    },
  },
  mounted() {
    this.getAssetLiability();
  },
  methods: {
    // 资产负债信息
    getAssetLiability() {
      const parames = {
        data: {
          cis: this.cis,
          custRelationship: this.custRelationship,
        },
      };
      this.$_post(this.$API.getAssetLiability, parames).then((res) => {
        this.total = res.data.custFinanceSum;
        this.sumTotal.fixIncomeMoney = this.total.inFixIncomeMoney + this.total.outFixIncomeMoney;
        this.sumTotal.currencyMoney = this.total.inCurrencyMoney + this.total.outCurrencyMoney;
        this.sumTotal.equityMoney = this.total.inEquityMoney + this.total.outEquityMoney;
        this.sumTotal.commodityMoney = this.total.inCommodityMoney + this.total.outCommodityMoney;
        this.beforeTotal.fixIncomeMoney = this.total.inFixIncomeMoney + this.total.outFixIncomeMoney;
        this.beforeTotal.currencyMoney = this.total.inCurrencyMoney + this.total.outCurrencyMoney;
        this.beforeTotal.equityMoney = this.total.inEquityMoney + this.total.outEquityMoney;
        this.beforeTotal.commodityMoney = this.total.inCommodityMoney + this.total.outCommodityMoney;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < res.data.custFinanceList.length; i++) {
          if (res.data.custFinanceList[i].isBank === '0') {
            this.within = res.data.custFinanceList[i];
          } else if (res.data.custFinanceList[i].isBank === '1') {
            this.external = res.data.custFinanceList[i];
            this.otherFixedIncomeAssets = res.data.custFinanceList[i].otherFixedIncomeAssets;
            this.otherMonetaryAssets = res.data.custFinanceList[i].otherMonetaryAssets;
            this.otherEquityAssets = res.data.custFinanceList[i].otherEquityAssets;
            this.otherCommodityAssets = res.data.custFinanceList[i].otherCommodityAssets;
          }
        }
      });
    },
    // 修改方法
    modify() {
      if (this.sumTotal.fixIncomeMoney < this.total.inFixIncomeMoney) {
        this.$message.error(`请输入大于等于固收类中行内资产${this.total.inFixIncomeMoney}的值`);
        this.sumTotal.fixIncomeMoney = this.beforeTotal.fixIncomeMoney;
        this.$emit('ModificationFailed', false);
        return;
      }
      if (this.sumTotal.currencyMoney < this.total.inCurrencyMoney) {
        this.$message.error(`请输入大于等于货币类中行内资产${this.total.inCurrencyMoney}的值`);
        this.sumTotal.currencyMoney = this.beforeTotal.currencyMoney;
        this.$emit('ModificationFailed', false);
        return;
      } if (this.sumTotal.equityMoney < this.total.inEquityMoney) {
        this.$message.error(`请输入大于等于权益类中行内资产${this.total.inEquityMoney}的值`);
        this.sumTotal.equityMoney = this.beforeTotal.equityMoney;
        this.$emit('ModificationFailed', false);
        return;
      } if (this.sumTotal.commodityMoney < this.total.inCommodityMoney) {
        this.$message.error(`请输入大于等于商品类中行内资产${this.total.inCommodityMoney}的值`);
        this.sumTotal.commodityMoney = this.beforeTotal.commodityMoney;
        this.$emit('ModificationFailed', false);
        return;
      }
      if (this.sumTotal.fixIncomeMoney < this.beforeTotal.fixIncomeMoney) {
        if (this.beforeTotal.fixIncomeMoney - this.sumTotal.fixIncomeMoney > this.external.otherFixedIncomeAssets) {
          debugger;
          this.$message.error('固收类行外其他资产资金不足，请手动调整资产类别的金额');
          this.external.otherFixedIncomeAssets = this.otherFixedIncomeAssets;
          this.sumTotal.fixIncomeMoney = this.beforeTotal.fixIncomeMoney;
          this.$emit('ModificationFailed', false);
          return;
        }
      }
      if (this.sumTotal.currencyMoney < this.beforeTotal.currencyMoney) {
        if (this.beforeTotal.currencyMoney - this.sumTotal.currencyMoney > this.external.otherMonetaryAssets) {
          this.$message.error('货币类行外其他资产资金不足，请手动调整资产类别的金额');
          this.external.otherMonetaryAssets = this.otherMonetaryAssets;
          this.sumTotal.currencyMoney = this.beforeTotal.currencyMoney;
          this.$emit('ModificationFailed', false);
          return;
        }
      }
      if (this.sumTotal.equityMoney < this.beforeTotal.equityMoney) {
        if (this.beforeTotal.equityMoney - this.sumTotal.equityMoney > this.external.otherEquityAssets) {
          this.$message.error('权益类行外其他资产资金不足，请手动调整资产类别的金额');
          this.external.otherEquityAssets = this.otherEquityAssets;
          this.sumTotal.equityMoney = this.beforeTotal.equityMoney;
          this.$emit('ModificationFailed', false);
          return;
        }
      }
      if (this.sumTotal.commodityMoney < this.beforeTotal.commodityMoney) {
        if (this.beforeTotal.commodityMoney - this.sumTotal.commodityMoney > this.external.otherCommodityAssets) {
          this.$message.error('商品类行外其他资产资金不足，请手动调整资产类别的金额');
          this.external.otherCommodityAssets = this.otherCommodityAssets;
          this.sumTotal.commodityMoney = this.beforeTotal.commodityMoney;
          this.$emit('ModificationFailed', false);
          return;
        }
      }
      const parames = {
        data: {
          cis: this.cis,
          self: this.custRelationship,
          custFinanceInfo: this.external,
          fixIncomeDifferenceValue: this.sumTotal.fixIncomeMoney - this.beforeTotal.fixIncomeMoney,
          currencyDifferenceValue: this.sumTotal.currencyMoney - this.beforeTotal.currencyMoney,
          equityDifferenceValue: this.sumTotal.equityMoney - this.beforeTotal.equityMoney,
          commodityDifferenceValue: this.sumTotal.commodityMoney - this.beforeTotal.commodityMoney,
        },
      };
      this.$_post(this.$API.modifyLiabilities, parames).then((res) => {
        console.log(res);
        this.$emit('ModificationFailed', true);
        this.getAssetLiability();
        if (res.errorCode === 'E00000') {
          this.$message({
            message: res.errorMsg,
            type: 'success',
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.wholeEdit {
  display: flex;
  flex-direction: column;
  .wholeEdit-left {
    width: 100% !important;
    .top {
      img {
        position: relative;
        top: 3px;
        margin-right: 8px;
      }
      height: 60px;
      border: 1px solid rgba(220, 223, 230, 1);
      background: rgba(241, 247, 255, 1);
      display: flex;
      flex-direction: row;
      align-items: center;
      .money {
        display: flex;
        justify-content: space-between;
        text-align: right;
      }
    }
    .content-left {
      font-size: 14px;
      color: rgba(96, 98, 102, 1);
      border-right: 1px solid rgba(220, 223, 230, 1);
      border-top: 0px;
      background: rgba(245, 247, 250, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .content-Middle {
      padding: 0px;
      .background {
        background: rgba(245, 247, 250, 1);
      }
      .table {
        padding: 2px 0px;
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        justify-content: space-around;
        span {
          font-size: 12px;
          color: rgba(48, 49, 51, 1);
        }
        .within {
          position: relative;
          left: 42px;
        }
        .external {
          position: relative;
          left: -32px;
          // top: -15px;
        }
      }
    }
    .content-right {
      color: rgba(48, 49, 51, 1);
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .wholeEdit-right {
    // margin-left: 2%;
    width: 100% !important;
    .el-input__inner{
      margin-left: 23px !important;
    }
    .top {
      height: 225px;
      border: 1px solid rgba(220, 223, 230, 1);
      .first-line {
        padding: 0px 30px 0px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(241, 247, 255, 1);
        border-bottom: 1px solid rgba(220, 223, 230, 1);
        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }
      .content {
        padding: 0px;
        .background {
          background: rgba(245, 247, 250, 1);
        }
        .table {
          height: 30px;
          padding: 4.5px 32px 4.5px 37px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
          input{
            position: relative;
           left: -18px;
          }
        }
      }
    }
    .bottom {
      height: 295px;
      border: 1px solid rgba(220, 223, 230, 1);
      margin-top: 40px;
      .first-line {
        padding: 0px 30px 0px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(241, 247, 255, 1);
        border-bottom: 1px solid rgba(220, 223, 230, 1);
        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }
      .content {
        padding: 0px;
        .background {
          background: rgba(245, 247, 250, 1);
        }
        .table {
          height: 30px;
          padding: 4.5px 32px 4.5px 37px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
          input{
            position: relative;
           left: -18px;
          }
        }
      }
    }
  }
}
</style>
